import { EditButton, DeleteButton, Stack } from "@pankod/refine-mui";

export default {
  title: "Gestori",
  resource: "users",
  canCreate: true,
  dataGridParams: {
    permanentFilter: [{ field: "role.name", operator: "eq", value: "owner" }],
  },
  columns: [
    { field: "firstName", headerName: "Nome", flex: 1, minWidth: 200 },
    { field: "lastName", headerName: "Cognome", flex: 1, minWidth: 200 },
    { field: "email", headerName: "Email", flex: 1, minWidth: 300 },
    { field: "username", headerName: "Username", flex: 1, minWidth: 300 },
    {
      headerName: "Azioni",
      field: "actions",
      minWidth: 150,
      renderCell: function render(params) {
        return (
          <Stack direction="row" spacing={1}>
            {/*<EditButton hideText recordItemId={params.row.id} />*/}
            <DeleteButton hideText recordItemId={params.row.id} />
          </Stack>
        );
      },
    },
  ],
};
